import script from "./EvaluationArea.vue?vue&type=script&setup=true&lang=js"
export * from "./EvaluationArea.vue?vue&type=script&setup=true&lang=js"

import "./EvaluationArea.vue?vue&type=style&index=0&id=8e6c0d40&scoped=true&lang=css"
import "./EvaluationArea.vue?vue&type=style&index=1&id=8e6c0d40&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e6c0d40"]])

export default __exports__